// Utility function to select a league by its ID and update the state with league details
import API_BASE_URL from './apiConfig'; // Import API base URL

export const selectLeagueById = async ({
  leagueId,
  leagues,
  setSelectedLeague,
  setInviteStatus,
  setError,
}) => {
  if (!leagueId) {
    console.warn("No leagueId provided to selectLeagueById");
    setError("No league selected.");
    return;
  }

  if (!Array.isArray(leagues) || leagues.length === 0) {
    console.warn("selectLeagueById: leagues list is not ready yet.");
    setError("Leagues data is not available.");
    return;
  }

  const leagueSummary = leagues.find(l => l.leagueId === leagueId);

  if (!leagueSummary) {
    console.error("Could not find league in userLeagues list");
    setError("Could not find selected league");
    return;
  }

  try {
    const res = await fetch(`${API_BASE_URL}/api/leagues/${leagueId}`, {
      credentials: "include",
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.message || "Failed to fetch league details");
    }

    const mergedLeague = {
      ...data,
      inviteStatus: leagueSummary.inviteStatus,
    };

    setSelectedLeague(mergedLeague);
    setInviteStatus(leagueSummary.inviteStatus);

    return mergedLeague; // Useful for guards or redirects

  } catch (err) {
    console.error("Error selecting league:", err);
    setError(err.message || "Unknown error selecting league.");
  }
};
